/**
 * Handles the issue of the url being built with a trailing slash
 * @param url The url to be parsed
 * @returns The parsed url
 */
export const handleTrailingSlash = (url: string) => {
	const protocol = url.split("://")[0];
	const path = url.split("://")[1].replace("//", "/");
	return `${protocol}://${path}`;
};
